import { FoodsTextInput } from "@foodpilot/foods";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { queryClient } from "src/_Globals/queryClient/queryClient";
import { useUpsertAppParam } from "src/api/client-api/appParams";
import {
    ApplicationParameterKeys,
    appParamCacheKey,
    useApplicationParameters,
} from "src/api/client-api/appParams/useApplicationParameters";
import { useDeleteAppParam } from "src/api/client-api/appParams/useDeleteAppParam";

type BaseStringUploadProps = {
    appParamKey: ApplicationParameterKeys;
    label: string;
    description?: string;
    placeholder?: string;
    forceReload?: boolean;
};
export const BaseStringUpload = (props: BaseStringUploadProps) => {
    const { label, description, placeholder = "" } = props;

    const { applicationParameters } = useApplicationParameters();

    const upsertAppParam = useUpsertAppParam({ forceReload: props.forceReload });
    const deleteAppParam = useDeleteAppParam();
    const { t } = useTranslation();

    const originalValue = applicationParameters?.[props.appParamKey];
    const [value, setValue] = useState(originalValue ?? null);

    const pushUpdate = (valueToSend: string | null) => {
        if (valueToSend === null || valueToSend === "") {
            return deleteAppParam.mutate({ key: props.appParamKey });
        }

        upsertAppParam.mutate(
            {
                isNew: originalValue === undefined ? true : false,
                key: props.appParamKey,
                value: valueToSend,
            },
            {
                onSuccess: () => {
                    queryClient.refetchQueries([appParamCacheKey]);
                },
            },
        );
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "row", height: "75px", gap: "16px" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box sx={{ display: "flex", gap: "16px" }}>
                    <Typography variant="big-bold">{`${label}`}</Typography>
                    <Typography variant="big-bold">{`-`}</Typography>
                    <Typography variant="body-medium">{`${description}`}</Typography>
                </Box>
                <Stack flexDirection={"row"} gap={"16px"}>
                    <FoodsTextInput
                        ExtraInputProps={{ placeholder }}
                        value={value ?? ""}
                        onChange={(newValue) => {
                            setValue(newValue);
                        }}
                    />
                    <Button
                        variant={"ternary"}
                        onClick={() => {
                            pushUpdate(null);
                        }}
                    >
                        {"Reset"}
                    </Button>
                </Stack>
                <Button
                    sx={{ display: "flex", justifyContent: "left" }}
                    variant="text"
                    onClick={() => {
                        pushUpdate(value);
                    }}
                >
                    {t("primarydialog.validate")}
                </Button>
            </Box>
        </Box>
    );
};
